var map = {
	"../pages/about/about.module": [
		1064,
		72
	],
	"../pages/accident-table/accident-table.module": [
		1065,
		5
	],
	"../pages/accident/accident.module": [
		1066,
		71
	],
	"../pages/ad-accident-details/ad-accident-details.module": [
		1067,
		70
	],
	"../pages/ad-allkaizen/ad-allkaizen.module": [
		1068,
		69
	],
	"../pages/ad-allkaizenadmin_NOt_USED/ad-allkaizenadmin.module": [
		1069,
		68
	],
	"../pages/ad-kaizen-table/ad-kaizen-table.module": [
		1070,
		7
	],
	"../pages/ad-kaizen-tablenew/ad-kaizen-tablenew.module": [
		1071,
		4
	],
	"../pages/ad-kaizen/ad-kaizen.module": [
		1072,
		67
	],
	"../pages/ad-nearmiss-details/ad-nearmiss-details.module": [
		1073,
		66
	],
	"../pages/ad-nearmiss/ad-nearmiss.module": [
		1074,
		65
	],
	"../pages/ad-observation-details/ad-observation-details.module": [
		1075,
		64
	],
	"../pages/ad-oseservation/ad-oseservation.module": [
		1076,
		63
	],
	"../pages/ad-safety/ad-safety.module": [
		1077,
		62
	],
	"../pages/adkaizen-details/adkaizen-details.module": [
		1078,
		60
	],
	"../pages/adkaizen-details1/adkaizen-details1.module": [
		1079,
		61
	],
	"../pages/admin-broadcast/admin-broadcast.module": [
		1080,
		59
	],
	"../pages/admin-panel/admin-panel.module": [
		1081,
		58
	],
	"../pages/admin/admin.module": [
		1082,
		57
	],
	"../pages/adview-safety/adview-safety.module": [
		1083,
		56
	],
	"../pages/after-img/after-img.module": [
		1084,
		55
	],
	"../pages/auth/auth.module": [
		1085,
		54
	],
	"../pages/before-img/before-img.module": [
		1086,
		0
	],
	"../pages/coc/coc.module": [
		1087,
		10
	],
	"../pages/complaint/complaint.module": [
		1088,
		53
	],
	"../pages/departments/departments.module": [
		1089,
		52
	],
	"../pages/display/display.module": [
		1090,
		51
	],
	"../pages/displays/displays.module": [
		1091,
		50
	],
	"../pages/edit-kaizen/edit-kaizen.module": [
		1092,
		49
	],
	"../pages/ethics-list/ethics-list.module": [
		1093,
		48
	],
	"../pages/ethics-notfication-details/ethics-notfication-details.module": [
		1094,
		47
	],
	"../pages/ethics-table/ethics-table.module": [
		1095,
		3
	],
	"../pages/home/home.module": [
		1096,
		46
	],
	"../pages/hr-admin/hr-admin.module": [
		1097,
		8
	],
	"../pages/hr-manage-users/hr-manage-users.module": [
		1098,
		45
	],
	"../pages/hr-manage/hr-manage.module": [
		1099,
		44
	],
	"../pages/hrform/hrform.module": [
		1100,
		43
	],
	"../pages/image-click/image-click.module": [
		1101,
		11
	],
	"../pages/kaizen-details/kaizen-details.module": [
		1102,
		42
	],
	"../pages/kaizen-kpi/kaizen-kpi.module": [
		1103,
		41
	],
	"../pages/list/list.module": [
		1104,
		37
	],
	"../pages/list1/list1.module": [
		1105,
		40
	],
	"../pages/list2/list2.module": [
		1106,
		39
	],
	"../pages/list3/list3.module": [
		1107,
		38
	],
	"../pages/listd/listd.module": [
		1108,
		36
	],
	"../pages/login/login.module": [
		1109,
		35
	],
	"../pages/near-miss/near-miss.module": [
		1110,
		34
	],
	"../pages/nm-table/nm-table.module": [
		1111,
		2
	],
	"../pages/notifications/notifications.module": [
		1112,
		33
	],
	"../pages/obs-table/obs-table.module": [
		1113,
		1
	],
	"../pages/pdf-view/pdf-view.module": [
		1114,
		9
	],
	"../pages/safe-observation/safe-observation.module": [
		1115,
		32
	],
	"../pages/safety-list/safety-list.module": [
		1116,
		31
	],
	"../pages/safety-table/safety-table.module": [
		1117,
		6
	],
	"../pages/status-details/status-details.module": [
		1118,
		30
	],
	"../pages/submit-kaizen/submit-kaizen.module": [
		1119,
		29
	],
	"../pages/tabs/tabs.module": [
		1120,
		28
	],
	"../pages/us-accident-details/us-accident-details.module": [
		1121,
		27
	],
	"../pages/us-accident-view/us-accident-view.module": [
		1122,
		26
	],
	"../pages/us-broacast-notification/us-broacast-notification.module": [
		1123,
		25
	],
	"../pages/us-broadcast-details/us-broadcast-details.module": [
		1124,
		24
	],
	"../pages/us-complaint/us-complaint.module": [
		1125,
		23
	],
	"../pages/us-nearmiss-details/us-nearmiss-details.module": [
		1126,
		22
	],
	"../pages/us-nearmiss-view/us-nearmiss-view.module": [
		1127,
		21
	],
	"../pages/us-observation-details/us-observation-details.module": [
		1128,
		20
	],
	"../pages/us-observation-view/us-observation-view.module": [
		1129,
		19
	],
	"../pages/user-approved/user-approved.module": [
		1130,
		18
	],
	"../pages/user-notification/user-notification.module": [
		1131,
		17
	],
	"../pages/user-safety-view/user-safety-view.module": [
		1132,
		16
	],
	"../pages/view-brodcast-notifications/view-brodcast-notifications.module": [
		1133,
		15
	],
	"../pages/view-ethics/view-ethics.module": [
		1134,
		14
	],
	"../pages/view-kaizen/view-kaizen.module": [
		1135,
		13
	],
	"../pages/view-safety/view-safety.module": [
		1136,
		12
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 264;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 264
// module chunks = 73